import { RouteEntityApi, UserRouteProgressEntityApi } from './route.api-model';
import { Route, UserRouteProgress } from './route.vm';

export const mapRouteFromApiToVm = (route: RouteEntityApi): Route => ({
  id: route.id,
  title: route.title,
  description: route.description,
  type: route.type,
  coverImage: route?.coverImage?.url,
  progress: route.progress,
  progressStatus: route.progressStatus ?? 'NOT_STARTED',
  order: route.order,
  lastInteraction: route.lastInteraction,
  userRouteProgressId: route.userRouteProgressId,
  stagesProgress: route.stagesProgress,
});

export const mapUserRouteProgressFromApiToVm = (
  userRouteProgress: UserRouteProgressEntityApi,
): UserRouteProgress => ({
  id: userRouteProgress.id,
  userId: userRouteProgress.userId,
  routeId: userRouteProgress.routeId,
  status: userRouteProgress.status,
  progress: userRouteProgress.progress,
  user: `${userRouteProgress.user.firstName} ${userRouteProgress.user.lastName}`,
  email: userRouteProgress.user.email,
  lastVisitedAt: userRouteProgress.lastVisitedAt,
  stagesProgress: userRouteProgress.stagesProgress,
});

export const mapRouteCollectionFromApiToVm = (routes: RouteEntityApi[]): Route[] =>
  routes.map(mapRouteFromApiToVm);

export const mapUserRouteProgressCollectionFromApiToVm = (
  userRouteProgresses: UserRouteProgressEntityApi[],
): UserRouteProgress[] => userRouteProgresses.map(mapUserRouteProgressFromApiToVm);
